export const defaultLimitPagination = 100
export const fiftyLimitPagination = 50
